$(document).ready(function() {
    let divMain = $('.tags--horizontal')[0];
    let position = $(divMain).children().position().left;
    const slideAmount = 150;
  
    $('#arrow-right').click(function() {
      $(divMain).animate({
        scrollLeft: position + slideAmount
      }, 500);
      position += slideAmount;
    })
  
    $('#arrow-left').click(function() {
      $(divMain).animate({
        scrollLeft: position - slideAmount
      }, 500);
      position -= slideAmount;
    })
  });